export enum TypeInRoute {
  Doc = 'doc',
  Api = 'api',
  DeprecatedApi = 'endpoint',
  WebSocketApi = 'websocket',
  ApiCase = 'api-case',
  ApiFolder = 'folder',
  CustomEndpoint = 'custom-endpoint',
  SocketIOApi = 'socket-io',
  ApiSchema = 'schema',
}
